import { render, staticRenderFns } from "./key.vue?vue&type=template&id=1490a123&scoped=true&"
import script from "./key.vue?vue&type=script&lang=js&"
export * from "./key.vue?vue&type=script&lang=js&"
import style0 from "./key.vue?vue&type=style&index=0&id=1490a123&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1490a123",
  null
  
)

export default component.exports